<template>
  <div
    id="pay-ment"
    @click="handleClick">
    <!-- <div class="pay-title"></div> -->
    <div class="pay-content">
      <div class="content-header">
        <div class="header-title">My Existing Subscriptions</div>
        <div class="heaer-filter">
          <div
            class="filter-wrap"
            ref="filterWrap"
            v-show="showFilter">
            <el-checkbox
              v-model="checkAllServer"
              @change="handleCheckAllChange">Select All</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group
              v-model="checkServerList"
              @change="handleCheckedCitiesChange">
              <el-checkbox
                v-for="server in serviceFilterList"
                :label="server"
                :key="server">{{server}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <span
            class="iconfont icon-filter"
            @click="showFilter = !showFilter"></span>
        </div>
      </div>
      <div class="content-table">
        <el-table
          :data="planList"
          stripe
          @cell-mouse-enter="handleEnter"
          @cell-mouse-leave="handleLeave"
          style="width: 100%">
          <el-table-column
            prop="serviceType"
            label="Service"
            width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Subscription Type"
            width="180">
            <template slot-scope="scope">
              <div
                v-for="plan in scope.row.plans"
                :key="plan.id">
                {{ plan.subscriptionType }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="Quantity">
            <template slot-scope="scope">
              <div
                v-for="plan in scope.row.plans"
                :key="plan.id">
                {{ plan.Quantity }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="Cost">
            <template slot-scope="scope">
              <div
                v-for="plan in scope.row.plans"
                :key="plan.id">
                {{ plan.Cost }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { userHasSubscription } from '@/common/checkuser.js'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      planList: [],
      basePlanList: [],
      serviceFilterList: [], // filter 的展示列表
      checkAllServer: true, // 是否全选
      checkServerList: [], // 选择的server list
      showFilter: false // 是否展示filter
    }
  },
  created () {
    this.getUserSub()
    this.$emit('titlechange', 'Plan Management')
  },
  methods: {
    handleLeave (row, column, cell, event) {
      console.log(row, column, cell, event)
      this.scrollDom.removeEventListener('scroll', this.handleScroll)
    },
    handleEnter (row, column, cell, event) {
      console.log(row, column, cell, event)
      const tr = cell.parentNode
      const tdList = tr.querySelectorAll('td')
      const scrollDom = cell.querySelector('.cell')
      this.scrollDom = scrollDom
      this.tdList = tdList
      scrollDom.addEventListener('scroll', this.handleScroll)
    },
    handleScroll (e) {
      const scrollTop = e.target.scrollTop

      this.tdList.forEach(e => {
        const dom = e.querySelector('.cell')
        dom.scrollTop = scrollTop
      })
    },
    getUserSub () {
      const params = {
        // product: 'Tvuchannel',
        status: 0
      }
      userHasSubscription(params).then(({ data }) => {
        console.log(data)
        if (data.subscription && data.subscription.subscriptions) {
          const subscriptions = data.subscription.subscriptions
          const arr = []
          const serverArr = []
          subscriptions.forEach(i => {
            i.subscriptionType = 'Prepaid Subscription'
            i.Quantity = i.chargeItems[0].quantity
            i.Cost = '$' + (i.price / 100).toFixed(2)
            switch (i.serviceType) {
              case 'Tvuchannel':
                i.serviceName = 'TVU Channel'
                i.Quantity = i.Quantity + ' Channels'
                break
              case 'Tvusearch':
                i.serviceName = 'TVU Search'
                break
              default:
                i.serviceName = i.serviceType
                break
            }
            const index = arr.findIndex(j => j.serviceType == i.serviceType)
            if (index > -1) {
              arr[index].plans.push(i)
            } else {
              arr.push({
                serviceType: i.serviceType,
                serviceName: i.serviceName,
                plans: [i]
              })
              serverArr.push(i.serviceName)
            }
          })
          console.log(arr)
          this.basePlanList = arr
          this.serviceFilterList = serverArr
          this.checkServerList = this.serviceFilterList
          console.log(this.checkServerList)
          // this.handleCheckedCitiesChange()
        }
      })
    },
    handleCheckAllChange (value) {
      console.log('aaa')
      if (value) {
        this.checkServerList = this.serviceFilterList
      } else {
        this.checkServerList = []
      }
    },
    handleCheckedCitiesChange () {
      this.checkAllServer = this.checkServerList.length == this.serviceFilterList.length
    },
    handleClick (e) {
      const className = e.target.className || ''
      if (className == 'iconfont icon-filter') return false
      this.showFilter = this.$refs.filterWrap.contains(e.target)
    }
  },
  watch: {
    checkServerList (arr) {
      this.planList = this.basePlanList.filter(i => arr.indexOf(i.serviceName) > -1)
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email
    })
  }
}
</script>

<style lang="less" scoped>
#pay-ment {
  width: 700px;
  .pay-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 18px;
    color: #444444;
    position: relative;
    top: -20px;
    border-bottom: 1px solid #dbdbdb;
    padding-bottom: 16px;
    text-align: left;
  }
  .content-header {
    display: flex;
    justify-content: space-between;
    .header-title {
      font-weight: 700;
      font-size: 20px;
      color: #252525;
      text-align: left;
    }
    .heaer-filter {
      margin-right: 30px;
      position: relative;
      .icon-filter {
        cursor: pointer;
        font-size: 24px;
      }
      .filter-wrap {
        padding: 15px 25px;
        position: absolute;
        right: 35px;
        z-index: 100;
        background-color: var(--plan-card-bg);
        box-shadow: 1px 1px 4px 1px #dba5a5;
        ::v-deep .el-checkbox {
          display: block;
          text-align: left;
          .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #33AB4F;
            border-color: #33AB4F;
          }
          .el-checkbox__label {
            color: var(--content-table-color);
          }
        }
      }
    }
  }
  .content-table {
    margin: 10px 0;
    ::v-deep .el-table {
      background-color: var(--plan-card-bg);
      color: var(--content-table-color);
      tr, th {
        background-color: var(--plan-card-bg);
      }
      .el-table__body tr:hover>td {
        background-color: var(--content-table-hover-bg);
      }
      td {
        border-color: var(--content-table-border-color);
        color: var(--content-table-color);
        background-color: var(--content-table-hover-bg);
      }
      .el-table__footer-wrapper td {
        border: none;
      }
      td, th.is-leaf {
        border-bottom-color: var(--content-table-border-color);
      }
      .el-table__row {
        .cell {
          overflow-y: scroll;
          max-height: 200px;
        }

        /* // 定义了滚动条整体的样式 */
        .cell::-webkit-scrollbar {
          width: 6px;
        }

        /* // 滑块部分 */
        .cell::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #626262;
        }

        /* // 轨道部分 */
        .cell::-webkit-scrollbar-thumb {}

      }

    }
  }
}
</style>
